module.exports = __webpack_public_path__ + "files/e4a9d34a18d7c5b553966eb0285c3032.png";